import { connect } from 'react-redux';
import TTMainGrid from './ttMainGrid';
import { bindActionCreators } from 'redux';
import { deleteRow, createMatchColListItem, fetchMatchColListItem, saveMatchColList, cancelMatchColList } from 'redux/translationTable/TranslationTableActions';

const mapStateToProps = ({ translationTable }) => ({
  sourceColumns: translationTable.sourceColumns,
  targetColumn: translationTable.targetColumn,
  rows: translationTable.rows,
  lists: translationTable.lists,
  changingColList: translationTable.changingColList,
  translationTableId: translationTable.translationTable.id,
  fetchingTranslationTableData: translationTable.fetchingTranslationTableData
});

const mapDispatchToProps = dispatch => ({
  ttActions: bindActionCreators({
    deleteRow,
    createMatchColListItem,
    fetchMatchColListItem,
    saveMatchColList,
    cancelMatchColList
  }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(TTMainGrid);



// WEBPACK FOOTER //
// ./src/shared/components/translationTable/c/ttRowManager/c/ttMainGrid/ttMainGridConnector.js